module.exports = new __parcel__URL__("stakeholders-skeleton.tpl.fdcae4e5.svg").toString();